<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{$t('apiDoc.在线文档')}}</span>
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >{{$t('apiDoc.测试工具')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'order/addLooseOrder';
export default {
  components: { onlineDoc , apiTestDoc },
  data() { 
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.OrderDescription_5')}`,
      //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
         //参数描述  START
       postDataList:[
            
        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: "接入方在平台的api账户标识",},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: "签名字符串",},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: "时间戳，毫秒",},
                    ]
            },
            { 
                title:'请求参数', 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型",},
                ]
            },
            {
              title:"业务参数",
              value:[
                {name: "salesmanCode",type: "String(30)",require: "N",normal: "",describe: "业务员编码（联系出货网点提供，且采用网点编码签名）"},
                {name: "digest",type: "String(50)",require: "N",normal: "",describe: "签名，Base64(Md5(客户编码/业务员编码+密文+privateKey))，其中密文：MD5(明文密码/网点编码+jadada236t2) 后大写"},
                {name: "billCode",type: "String(50)",require: "N",normal: "",describe: "运单编号"},
                {name: "txlogisticId",type: "String(50)",require: "Y",normal: "",describe: "客户订单号（传客户自己系统的订单号）"},
                {name: "expressType",type: "String(30)",require: "Y",normal: "",describe: "快件类型：EZ(标准快递)"},
                {name: "orderType",type: "String(11)",require: "Y",normal: "",describe: "订单类型  1、散客；   "},
                {name: "serviceType",type: "String(30)",require: "Y",normal: "",describe: "服务类型    02 门店寄件 01 上门取件"},
                {name: "deliveryType",type: "String(30)",require: "Y",normal: "",describe: "派送类型  06 代收点自提  05 快递柜自提  04 站点自提  03 派送上门 "},
                {name: "payType",type: "String(30)",require: "N",normal: "",describe: "支付方式CC_CASH(“到付现结”);PP_CASH（“寄付现结”）"},
                {name: "sender",type: "Object",require: "Y",normal: "",describe: "寄件信息对象"},
                {name: "receiver",type: "Object",require: "Y",normal: "",describe: "收件信息对象"},
                {name: "sendStartTime",type: "String(30)",require: "N",normal: "",describe: "物流公司上门取货开始时间 yyyy-MM-dd HH:mm:ss"},
                {name: "sendEndTime",type: "String(30)",require: "N",normal: "",describe: "物流公司上门取货结束时间 yyyy-MM-dd HH:mm:ss"},
                {name: "goodsType",type: "String(30)",require: "Y",normal: "",describe: "物品类型（对应订单主表物品类型）:<p>bm000001 文件</p>  <p>bm000002 数码产品</p>  <p>bm000003 生活用品</p>  <p>bm000004  食品</p>  <p>bm000005  服饰</p>  <p>bm000006  其他</p>  <p>bm000007 生鲜类</p>  <p>bm000008 易碎品</p><p>bm000009 液体</p>"},
                {name: "length",type: "int(6)",require: "N",normal: "",describe: "长，cm"},
                {name: "width",type: "int(6)",require: "N",normal: "",describe: "宽，cm"},
                {name: "height",type: "int(6)",require: "N",normal: "",describe: "高，cm"},
                {name: "weight",type: "String(12)",require: "N",normal: "0.02",describe: "重量，单位kg，范围0.01-30"},
                {name: "totalQuantity",type: "int(4)",require: "N",normal: "",describe: "包裹总票数(必须为1)"},
                {name: "itemsValue",type: "String(12)",require: "N",normal: "",describe: "代收货款金额 (数值型)"},
                {name: "priceCurrency",type: "String(32)",require: "N",normal: "",describe: "代收货款币别（默认本国币别，如：RMB"},
                {name: "offerFee",type: "String(12)",require: "N",normal: "",describe: "保价金额(数值型)，单位：元"},
                {name: "remark",type: "String(200)",require: "N",normal: "",describe: "备注"},
                {name: "items",type: "Object",require: "N",normal: "",describe: "商品信息列表"},
              ]
            },
            {
              title:"sender类型说明",
              value:[
                {name: "name",type: "String(32)",require: "Y",normal: "",describe: "寄件人姓名"},
                {name: "company",type: "String(100)",require: "N",normal: "",describe: "寄件公司"},
                {name: "postCode",type: "String(32)",require: "N",normal: "",describe: "寄件邮编"},
                {name: "mailBox",type: "String(150)",require: "N",normal: "",describe: "寄件邮箱"},
                {name: "mobile",type: "String(30)",require: "Y",normal: "",describe: "寄件手机（手机和电话二选一必填）"},
                {name: "phone",type: "String(30)",require: "Y",normal: "",describe: "寄件电话（手机和电话二选一必填）"},
                {name: "countryCode",type: "String(20)",require: "Y",normal: "",describe: "寄件国家三字码（如：中国=CHN、印尼=IDN）"},
                {name: "prov",type: "String(32)",require: "Y",normal: "",describe: "寄件省份"},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe: "寄件城市"},
                {name: "area",type: "String(32)",require: "Y",normal: "",describe: "寄件区域"},
                {name: "town",type: "String(32)",require: "N",normal: "",describe: "寄件乡镇"},
                {name: "street",type: "String(32)",require: "N",normal: "",describe: "寄件街道"},
                {name: "address",type: "String(150)",require: "Y",normal: "",describe: "寄件详细地址（省+市+区县+详细地址）"}
              ]
            },
            {
              title:"receiver类型说明",
              value:[
                {name: "name",type: "String(32)",require: "Y",normal: "",describe: "收件人姓名"},
                {name: "company",type: "String(100)",require: "N",normal: "",describe: "收件公司"},
                {name: "postCode",type: "String(32)",require: "N",normal: "",describe: "收件邮编"},
                {name: "mailBox",type: "String(150)",require: "N",normal: "",describe: "收件邮箱"},
                {name: "mobile",type: "String(30)",require: "Y",normal: "",describe: "收件手机（手机和电话二选一必填）"},
                {name: "phone",type: "String(30)",require: "Y",normal: "",describe: "收件电话（手机和电话二选一必填）"},
                {name: "countryCode",type: "String(20)",require: "Y",normal: "",describe: "收件国家三字码（如：中国=CHN、印尼=IDN）"},
                {name: "prov",type: "String(32)",require: "Y",normal: "",describe: "收件省份"},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe: "收件城市"},
                {name: "area",type: "String(32)",require: "Y",normal: "",describe: "收件区域"},
                {name: "town",type: "String(32)",require: "N",normal: "",describe: "收件乡镇"},
                {name: "street",type: "String(32)",require: "N",normal: "",describe: "收件街道"},
                {name: "address",type: "String(150)",require: "Y",normal: "",describe: "收件详细地址（省+市+区县+详细地址）"}
              ]
            },
            {
              title:"items类型说明",
              value:[
                {name: "itemType",type: "String(30)",require: "N",normal: "",describe: "物品类型: <p>bm000001 文件</p>  <p>bm000002 数码产品</p>  <p>bm000003 生活用品</p>  <p>bm000004  食品</p>  <p>bm000005  服饰</p>  <p>bm000006  其他</p>  <p>bm000007 生鲜类</p>  <p>bm000008 易碎品</p><p>bm000009 液体</p>"},
                {name: "itemName",type: "String(30)",require: "N",normal: "",describe: "物品名称"},
                {name: "chineseName",type: "String(60)",require: "N",normal: "",describe: "物品中文名称"},
                {name: "englishName",type: "String(60)",require: "N",normal: "",describe: "物品英文名称"},
                {name: "number",type: "int(4)",require: "N",normal: "",describe: "件数，≤1"},
                {name: "itemValue",type: "String(20)",require: "N",normal: "",describe: "申报价值(数值型)"},
                {name: "priceCurrency",type: "String(20)",require: "N",normal: "",describe: "申报货款币别（默认本国币别，如：RMB）"},
                {name: "desc",type: "String(100)",require: "N",normal: "",describe: "物品描述"},
                {name: "itemUrl",type: "String(100)",require: "N",normal: "",describe: "商品URL"}
              ]
            }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[
            
        //   响应参数
            {
                title:'响应参数',
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: "返回码，见附录"},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: "描述"},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: "业务数据"},
                  ]
            },
            {
              title:"data类型说明",
              value:[
                  {name: "txlogisticId",type: "String",require: "Y",normal: "",describe: "返回客户订单号"},
                  {name: "orderId",type: "String",require: "Y",normal: "",describe: "返回极兔订单号"},
                  {name: "createOrderTime",type: "String",require: "Y",normal: "",describe: "订单创建时间 yyyy-MM-dd HH:mm:ss"},
                ]
            }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1627
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent={
{
	"txlogisticId": "10000000001299",
	"orderType": 1,
	"expressType": "EZ",
	"serviceType": "01",
	"deliveryType": "03",
	"sender": {
		"name": "李白",
		"company": "天美工作室",
		"postCode": "518000",
		"mailBox": "ant_li@qq.com",
		"mobile": "13421747372",
		"phone": "",
		"countryCode": "CHN",
		"prov": "山东省",
		"city": "淄博",
		"area": "沂源县",
		"town": "南山区",
		"street": "粤海街道",
		"address": "粤美特大厦"
	},
	"receiver": {
		"name": "高渐离",
		"company": "天美工作室",
		"postCode": "518000",
		"mailBox": "ant_li@qq.com",
		"mobile": "13421747372",
		"phone": "",
		"countryCode": "CHN",
		"prov": "山东省",
		"city": "淄博",
		"area": "沂源县",
		"town": "南山区",
		"street": "粤海街道",
		"address": "粤美特大厦"
	},
	"sendStartTime": "2019-08-06 15:00:00",
	"sendEndTime": "2019-08-06 15:30:00",
	"goodsType": "bm000001",
	"length": 50,
	"width": 50,
	"height": 1,
	"volume": 250,
	"weight": 1,
	"totalQuantity": 1,
	"itemsValue": "200",
	"priceCurrency": "RMB",
"payType":"CC_CASH",
	"offerFee": "200000",
	"remark": "重要文件",
	"createOrderTime": "2019-08-06 15:30:00",
	"items": [{
		"itemType": "文件",
		"itemName": "文件",
		"chineseName": "文件C",
		"englishName": "文件E",
		"Number()": "1",
		"itemValue": "200000",
		"priceCurrency": "RMB",
		"desc": "文件",
		"itemUrl": ""
	}]
}
}`,
        //返回示例
        responseCode: JSON.parse(
          `{"code": "1","msg": "success","data": {"txlogisticId": "10000000001299",
        "orderId": "YL1234567890123",
        "createOrderTime": "2019-08-09 18:15:30"}}`
        ),

        
        //错误代码提示
        errcodeJson: [{code:'145002002',msg:"运单重复,请勿使用相同运单号！"},{code:'145003042',msg:"修改订单失败"},{code:'145003111',msg:"批次号无效！"},
        {code:'145003060',msg:"区域不合法"},{code:'145003061',msg:"城市不合法"},{code:'145003062',msg:"省份不合法"},
        {code:'145003064',msg:"查不到数据"},{code:'145003041',msg:"下单失败"},{code:'145003083',msg:"发件人信息不全"},
        {code:'145003112',msg:"该批次号运单无效！"},{code:'145002001',msg:"订单重复,无需重复下单！"},{code:'145003084',msg:"收件人信息不全"},
        {code:'145003085',msg:"电话号码不能为空"},{code:'145003086',msg:"地址信息不全"},{code:'145003087',msg:"请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法"},
        {code:'145003200',msg:"请检查服务类型是否合法值为 01或 02"},{code:'145003088',msg:"上门服务时间信息不全"},{code:'145003092',msg:"重量信息不合法"},
        {code:'145003093',msg:"物品信息不全"},{code:'145003094',msg:"物品名称不全"},{code:'145003095',msg:"物品类型不全"},
        {code:'145003096',msg:"物品数量非法"},{code:'145003099',msg:"非法金额"},{code:'145003100',msg:"运单号非法"},
        {code:'145003101',msg:"客户订单号已存在,无法下单！"},{code:'145003103',msg:"姓名信息非法"},{code:'145003104',msg:"公司信息过长"},
        {code:'145003105',msg:"联系信息过长"},{code:'145003106',msg:"邮编或邮箱信息非法"},{code:'145003107',msg:"价格信息非法"},
        {code:'145003108',msg:"备注、描述、链接信息非法"},{code:'145003109',msg:"地址信息过长"},{code:'145003110',msg:"街道信息过长"},
        {code:'145003111',msg:"包裹总件数无效"},{code:'145003112',msg:"暂未开通代收货款业务"},
        {code:'145003201',msg:"已取件状态不可修改"},{code:'145003202',msg:"已取消状态不可修改"},{code:'145003203',msg:"更新订单失败，请稍后重试！"},
        {code:'145003083',msg:"始发地信息不全"},{code:'145003084',msg:"收货地信息不全"},{code:'145003010',msg:"API账号不存在"},
        {code:'145003114',msg:"支付方式不匹配,PP_CASH,CC_CASH"},{code:'145003330',msg:"业务员状态异常"},{code:'145003332',msg:"请确认运单编号获取来源是否与下单来源一致"},{code:'145003333',msg:"运单编号已过期，请重新获取"}]
      },

      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `
{
	"txlogisticId": "10000000001299",
	"orderType": 1,
	"expressType": "EZ",
	"serviceType": "01",
	"deliveryType": "03",
	"sender": {
		"name": "李白",
		"company": "天美工作室",
		"postCode": "518000",
		"mailBox": "ant_li@qq.com",
		"mobile": "13421747372",
		"phone": "",
		"countryCode": "CHN",
		"prov": "山东省",
		"city": "淄博",
		"area": "沂源县",
		"town": "南山区",
		"street": "粤海街道",
		"address": "粤美特大厦"
	},
	"receiver": {
		"name": "高渐离",
		"company": "天美工作室",
		"postCode": "518000",
		"mailBox": "ant_li@qq.com",
		"mobile": "13421747372",
		"phone": "",
		"countryCode": "CHN",
		"prov": "山东省",
		"city": "淄博",
		"area": "沂源县",
		"town": "南山区",
		"street": "粤海街道",
		"address": "粤美特大厦"
	},
	"sendStartTime": "2019-08-06 15:00:00",
	"sendEndTime": "2019-08-06 15:30:00",
	"goodsType": "bm000001",
	"length": 50,
	"width": 50,
	"height": 1,
	"volume": 250,
	"weight": 1,
	"totalQuantity": 1,
	"itemsValue": "200",
	"priceCurrency": "RMB",
"payType":"CC_CASH",
	"offerFee": "200000",
	"remark": "重要文件",
	"createOrderTime": "2019-08-06 15:30:00",
	"items": [{
		"itemType": "文件",
		"itemName": "文件",
		"chineseName": "文件C",
		"englishName": "文件E",
		"Number()": "1",
		"itemValue": "200000",
		"priceCurrency": "RMB",
		"desc": "文件",
		"itemUrl": ""
	}]
}`
             },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
      
           
        //错误代码提示
        errcodeJson: [{code:'145002002',msg:"运单重复,请勿使用相同运单号！"},{code:'145003042',msg:"修改订单失败"},{code:'145003111',msg:"批次号无效！"},
        {code:'145003060',msg:"区域不合法"},{code:'145003061',msg:"城市不合法"},{code:'145003062',msg:"省份不合法"},
        {code:'145003064',msg:"查不到数据"},{code:'145003041',msg:"下单失败"},{code:'145003083',msg:"发件人信息不全"},
        {code:'145003112',msg:"该批次号运单无效！"},{code:'145002001',msg:"订单重复,无需重复下单！"},{code:'145003084',msg:"收件人信息不全"},
        {code:'145003085',msg:"电话号码不能为空"},{code:'145003086',msg:"地址信息不全"},{code:'145003087',msg:"请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法"},
        {code:'145003200',msg:"请检查服务类型是否合法值为 01或 02"},{code:'145003088',msg:"上门服务时间信息不全"},{code:'145003092',msg:"重量信息不合法"},
        {code:'145003093',msg:"物品信息不全"},{code:'145003094',msg:"物品名称不全"},{code:'145003095',msg:"物品类型不全"},
        {code:'145003096',msg:"物品数量非法"},{code:'145003099',msg:"非法金额"},{code:'145003100',msg:"运单号非法"},
        {code:'145003101',msg:"客户订单号已存在,无法下单！"},{code:'145003103',msg:"姓名信息非法"},{code:'145003104',msg:"公司信息过长"},
        {code:'145003105',msg:"联系信息过长"},{code:'145003106',msg:"邮编或邮箱信息非法"},{code:'145003107',msg:"价格信息非法"},
        {code:'145003108',msg:"备注、描述、链接信息非法"},{code:'145003109',msg:"地址信息过长"},{code:'145003110',msg:"街道信息过长"},
        {code:'145003111',msg:"包裹总件数无效"},{code:'145003112',msg:"暂未开通代收货款业务"},
        {code:'145003201',msg:"已取件状态不可修改"},{code:'145003202',msg:"已取消状态不可修改"},{code:'145003203',msg:"更新订单失败，请稍后重试！"},
        {code:'145003114',msg:"支付方式不匹配,PP_CASH,CC_CASH"},{code:'145003330',msg:"业务员状态异常"},{code:'145003332',msg:"请确认运单编号获取来源是否与下单来源一致"},{code:'145003333',msg:"运单编号已过期，请重新获取"}]
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>